export let EditarCategoriaRouteComponent = {
    selector: 'editarCategoriaRoute',
    template: require('./editar-categoria.html'),
    bindings: {
        categoria: '<',
        subcategoria: '<'
    },
    controller: class {

        nuevaCategoria;
        nuevaSubcategoria;
        editandoSubcategoria = false;

        /*@ngInject*/
        constructor(CategoriasService, $location, ToasterService) {
            Object.assign(this, {CategoriasService, $location, ToasterService});
            this.guardandoDatos = false;
        }

        $onInit() {
            if (this.subcategoria) {
                this.editandoSubcategoria = true;
            }
        }

        cambiarNombreCategoria() {
            if (!this.editandoSubcategoria) {
                if (this.nuevaCategoria) {
                    this.guardandoDatos = true;
                    this.CategoriasService.cambiarNombreCategoria(this.categoria, this.nuevaCategoria)
                        .then(res => {
                            this.ToasterService.popUp('success', 'Categoria', 'Se ha cambiado el nombre con exito.');
                            this.$location.path('/');
                        })
                        .catch(err => {
                            this.guardandoDatos = false;
                            this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
                        })
                } else {
                    this.ToasterService.popUp('info', 'Categoria', 'Escriba el nuevo nombre de la categoria.');
                }
            } else {
                if (this.nuevaSubcategoria) {
                    this.guardandoDatos = true;
                    this.CategoriasService.cambiarNombreSubcategoria(this.categoria, this.subcategoria, this.nuevaSubcategoria)
                        .then(res => {
                            this.ToasterService.popUp('success', 'Subcategoria', 'Se ha cambiado el nombre con exito.');
                            this.$location.path('/');
                        })
                        .catch(err => {
                            this.guardandoDatos = false;
                            this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
                        })
                } else {
                    this.ToasterService.popUp('info', 'Categoria', 'Escriba el nuevo nombre de la categoria.');
                }
            }
        }

    }
};


// WEBPACK FOOTER //
// ./client/app/categorias-route/editar/editar-categoria.component.js